export const deSlugify = (string: string) => {
  return string.replace(/-/g, ' ').replace(/_/g, '');
};

export const titleCase = (string: string) => {
  return string
    .split(' ')
    .map(word => word[0].toUpperCase() + word.slice(1))
    .join(' ');
};
